import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditNoteIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2176_3890",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 25,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .5,
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2176_3890)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.25 13.75C5.0375 13.75 4.85942 13.6777 4.71575 13.533C4.57192 13.3885 4.5 13.2093 4.5 12.9955C4.5 12.7818 4.57192 12.6042 4.71575 12.4625C4.85942 12.3208 5.0375 12.25 5.25 12.25H11.25C11.4625 12.25 11.6407 12.3223 11.7845 12.467C11.9282 12.6115 12 12.7907 12 13.0045C12 13.2182 11.9282 13.3958 11.7845 13.5375C11.6407 13.6792 11.4625 13.75 11.25 13.75H5.25ZM5.25 9.625C5.0375 9.625 4.85942 9.55267 4.71575 9.408C4.57192 9.2635 4.5 9.08433 4.5 8.8705C4.5 8.65683 4.57192 8.47917 4.71575 8.3375C4.85942 8.19583 5.0375 8.125 5.25 8.125H15.5C15.7125 8.125 15.8907 8.19733 16.0345 8.342C16.1782 8.4865 16.25 8.66567 16.25 8.8795C16.25 9.09317 16.1782 9.27083 16.0345 9.4125C15.8907 9.55417 15.7125 9.625 15.5 9.625H5.25ZM5.25 5.5C5.0375 5.5 4.85942 5.42767 4.71575 5.283C4.57192 5.1385 4.5 4.95933 4.5 4.7455C4.5 4.53183 4.57192 4.35417 4.71575 4.2125C4.85942 4.07083 5.0375 4 5.25 4H15.5C15.7125 4 15.8907 4.07233 16.0345 4.217C16.1782 4.3615 16.25 4.54067 16.25 4.7545C16.25 4.96817 16.1782 5.14583 16.0345 5.2875C15.8907 5.42917 15.7125 5.5 15.5 5.5H5.25ZM13.5 19.25V17.225C13.5 17.1322 13.5167 17.0423 13.55 16.9555C13.5833 16.8685 13.6417 16.7833 13.725 16.7L19.0153 11.4308C19.1671 11.2788 19.3358 11.1689 19.5215 11.1012C19.7072 11.0337 19.8917 11 20.075 11C20.275 11 20.4667 11.0375 20.65 11.1125C20.8333 11.1875 21 11.3 21.15 11.45L22.075 12.375C22.225 12.525 22.3333 12.6917 22.4 12.875C22.4667 13.0583 22.5 13.2417 22.5 13.425C22.5 13.6083 22.4625 13.7958 22.3875 13.9875C22.3125 14.1792 22.1993 14.351 22.048 14.503L16.8 19.775C16.7167 19.8583 16.6315 19.9167 16.5445 19.95C16.4577 19.9833 16.3678 20 16.275 20H14.25C14.0375 20 13.8594 19.9281 13.7158 19.7843C13.5719 19.6406 13.5 19.4625 13.5 19.25ZM20.075 14.4L21 13.425L20.075 12.5L19.125 13.45L20.075 14.4ZM15 18.5H15.95L18.975 15.45L18.525 14.975L18.05 14.525L15 17.55V18.5ZM15 18.5V17.55L18.05 14.525L18.975 15.45L15.95 18.5H15Z",
				fill: "#DA0B5B"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgEditNoteIcon);
export default ForwardRef;
